import React, { useEffect, useState } from "react";
import { UserConsumer } from "../UserContext";
import Aside from "./Aside";
import {
	Row,
	Col,
	DropdownToggle,
	DropdownItem,
	ButtonDropdown,
	DropdownMenu,
} from "reactstrap";
import "react-pro-sidebar/dist/css/styles.css";
import "../components/style/TopBar.scss";
import { FaBars } from "react-icons/fa";
import { AuthService } from "../configurations/AuthService";
import { Config } from "../configurations/config";
import { useHistory } from "react-router-dom";
import { AlertPopups } from "./AlertPopups";
import store from "./navbarRedux/store";
import { Provider } from "react-redux";
import DefaultUser from "../images/user.png";
const authService = new AuthService();

const logout = () => {
	AlertPopups.confirmBox
		.fire({
			text: `${"Are you sure you want to log out?"}`,
		})
		.then((result) => {
			if (result.value) {
				//clearing storage
				localStorage.clear();
				authService.logout();
			}
		});
};

export default (props) => {
	const [imagePath, setImagePath] = useState(DefaultUser);
    const [userDetails, setUserDetails] = useState({ name: "", empDesignation: "" });
	useEffect(() => {
        const updateUserDetails = () => {
            const storedUser = JSON.parse(localStorage.getItem("userDetails"));
            if (storedUser) {
                setUserDetails(storedUser);
                if (storedUser.empImagePath) {
                    setImagePath(`${Config.server_url}/${storedUser.empImagePath}?t=${new Date().getTime()}`);
                } else {
                    setImagePath(DefaultUser);
                }
            }
        };

        updateUserDetails(); // Load user details on mount

        window.addEventListener("storage", updateUserDetails); // Update when localStorage changes

        return () => {
            window.removeEventListener("storage", updateUserDetails);
        };
    }, []);
	const history = useHistory();
	const [dropdownOpen, setOpen] = useState(false);
	const [toggled, setToggled] = useState(false);
	const [activeItem, setActiveItem] = useState(null);
	const toggle = () => setOpen(!dropdownOpen);

	//function to handle side bar
	const handleToggleSidebar = (value) => {
		setToggled(value);
	};

	useEffect(() => {
		if (!sessionStorage.getItem("NavbarTab")) {
			if (sessionStorage.getItem("TopBarItem"))
				setActiveItem(sessionStorage.getItem("TopBarItem"));
			else setActiveItem("MyDashboard");
		}
		if (window.location.hash) {
			window.history.pushState({}, null, "/");
		}
	});
	return (
		<>
			<Provider store={store}>
				<UserConsumer>
					{(userDetails) => {
						return (
							<>
								<div
									className={`app ${
										toggled ? "toggled" : ""
									}`}
								>
									<div
										className="overlay"
										onClick={() =>
											handleToggleSidebar(false)
										}
									></div>
									<Aside
										toggled={toggled}
										handleToggleSidebar={
											handleToggleSidebar
										}
									/>

									{/*Button Container*/}
									<main className="pt-2 px-3 pb-4">
										<div id="main">
											<div>
												<Row className="userInfo">
													<Col className="infoSet">
														<div
															className="btn-toggle mr-auto"
															onClick={() =>
																handleToggleSidebar(
																	true
																)
															}
														>
															<FaBars />
														</div>
													</Col>

													{/* Drop Down container*/}
													<div className="btnGroup">
														<ButtonDropdown
															isOpen={
																dropdownOpen
															}
															toggle={toggle}
														>
															<DropdownToggle
																caret
																className="dropDown d-flex align-items-center "
															>
																<span className="marginSet">
																	{
																		userDetails.name
																	}
																	<br />
																	<span className="employee-designation">
																		{
																			userDetails.empDesignation
																		}
																	</span>
																</span>
															</DropdownToggle>
															<DropdownMenu>
																{/* My Profile*/}
																<DropdownItem
																	onClick={() => {
																		sessionStorage.setItem(
																			"TopBarTab",
																			"TopBarTab"
																		);
																		sessionStorage.setItem(
																			"TopBarItem",
																			"MyProfile"
																		);
																		sessionStorage.removeItem(
																			"NavbarTab"
																		);
																		sessionStorage.removeItem(
																			"NavbarItem"
																		);
																		history.push(
																			"/MyProfile"
																		);
																		window.location.reload();
																	}}
																	active={
																		activeItem ===
																		"MyProfile"
																	}
																>
																	My Profile
																</DropdownItem>
																{/* Logout*/}
																<DropdownItem
																	onClick={() => {
																		sessionStorage.removeItem(
																			"NavbarTab"
																		);
																		sessionStorage.removeItem(
																			"NavbarItem"
																		);

																		logout();
																	}}
																	active={
																		activeItem ===
																		"Logout"
																	}
																>
																	Logout
																</DropdownItem>
															</DropdownMenu>
														</ButtonDropdown>
													</div>

													{/* <div className="imageGrp pr-3">
														{userDetails.empImagePath ? (
															<img
																src={
																	Config.server_url +
																	"/" +
																	userDetails.empImagePath +
																	`?t=${new Date().getTime()}`
																}
																className="userImg"
																alt="User Img"
															/>
														) : (
															<img
																src={
																	DefaultUser
																}
																className="userImg"
																alt="User Img"
															/>
														)}
													</div> */}
													 <div className="imageGrp pr-3">
                            <img src={imagePath} className="userImg" alt="User" />
                        </div>
												</Row>
											</div>
											{props.children}
										</div>
									</main>
								</div>
							</>
						);
					}}
				</UserConsumer>
			</Provider>
		</>
	);
};
